import { mutateRequest, writeAtom } from "@/lib/swr";
import type { Engagement, Prd, Version } from "@/types/domain";

// Engagement rows carry their scheduled version denormalized
// (versionId + versionState/versionName/versionCode — server EngagementView).
// Components that think in "version" terms (labels, routes, state badges)
// get a Version-shaped view here; pool rows (no versionId) get undefined.
export const engagementVersion = (e: Engagement): Version | undefined =>
  e.versionId
    ? {
        id: e.versionId,
        pid: e.appId,
        versionName: e.versionName ?? undefined,
        versionCode: e.versionCode ?? undefined,
        state: e.versionState ?? undefined,
      }
    : undefined;

/** Scheduled version's state code; 0 while unscheduled / unknown. */
export const engagementState = (e: Engagement): number => e.versionState ?? 0;

/** App ids the PRD has a relation with (pool rows included). */
export const engagementAppIds = (prd: { engagements?: Engagement[] }): string[] =>
  (prd.engagements ?? []).map((e) => String(e.appId ?? ""));

// The service echoes the PRD detail after a scheduling change (add app /
// schedule / unschedule); its `engagements` are document-level, so they slot
// into whichever detail key the page holds. Lists revalidate in the
// background — only when mounted (WED-249).
export const applyScheduling = (prdId: string, saved: Prd) => {
  writeAtom<Prd>(`/prds/${prdId}`, (cur) => ({
    ...cur,
    engagements: saved.engagements ?? cur.engagements,
  }));
  mutateRequest("/prds");
  mutateRequest("/engagements");
};
